<template>
  <footer id="app-footer" class="app-footer-styled">
    <div class="container footer-container-styled">
      <div class="footer-column footer-logo-social-column">
        <img
          src="@/assets/Repaek_LOGO_h.png"
          alt="UAMAX Logo and Contact Icons"
          class="footer-brand-image"
        />
        <p class="footer-company-name">{{ $t("footer.companyName") }}</p>
      </div>

      <div class="footer-column footer-office-column">
        <h4>{{ $t("footer.ourOffice.title") }}</h4>
        <p>{{ $t("footer.ourOffice.addressLine1") }}</p>
        <p>{{ $t("footer.ourOffice.addressLine2") }}</p>
        <p>{{ $t("footer.ourOffice.addressLine3") }}</p>
        <p>{{ $t("footer.ourOffice.addressLine4") }}</p>
      </div>

      <div class="footer-column footer-contact-column">
        <h4>{{ $t("footer.contactUs.title") }}</h4>
        <p v-for="(item, index) in contactItems" :key="index">
          <span class="contact-label">{{ item.label }}:</span>
          <a :href="'mailto:' + item.email">{{ item.email }}</a>
        </p>
      </div>

      <div class="footer-column footer-legal-column">
        <h4>{{ $t("header.nav.legal") }}</h4>
        <ul class="footer-legal-list">
          <li v-for="item in legalNavItems" :key="item.key">
            <router-link :to="item.link">{{ item.name }}</router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom-bar">
      <div class="container footer-bottom-container">
        <p class="footer-copyright">
          <span>{{ $t("footer.copyright.text") }}</span>
          <span class="footer-copyright-links">
            <router-link to="/legal/legal-information">{{
              $t("footer.copyright.legalInfo")
            }}</router-link>
            <span class="link-separator">|</span>
            <router-link to="/legal/privacy-policy">{{
              $t("footer.copyright.privacy")
            }}</router-link>
            <span class="link-separator">|</span>
            <router-link to="/legal/terms-and-policies">{{
              $t("footer.copyright.terms")
            }}</router-link>
          </span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooterStyled",
  computed: {
    contactItems() {
      const items = this.$t("footer.contactUs.items", { returnObjects: true });
      return Array.isArray(items) ? items : [];
    },
    legalNavItems() {
      return [
        {
          key: "terms",
          name: this.$t("header.nav.legalDropdown.terms"),
          link: "/legal/terms-and-policies",
        },
        {
          key: "privacy",
          name: this.$t("header.nav.legalDropdown.privacy"),
          link: "/legal/privacy-policy",
        },
        {
          key: "legalInfo",
          name: this.$t("header.nav.legalDropdown.legalInfo"),
          link: "/legal/legal-information",
        },
      ];
    },
  },
};
</script>

<style scoped>
.app-footer-styled {
  background-color: #1a1a2e; /* Darker, more modern color than 3b5998 */
  color: #ffffff;
  padding: 60px 0 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.footer-container-styled {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 60px;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1.2fr 0.8fr; /* Adjusted proportions */
  gap: 40px;
  align-items: flex-start;
}

.footer-column {
  padding-top: 10px;
}

.footer-logo-social-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align left */
  /* justify-content: center; */
  padding-top: 0px; /* Removed extra padding */
}

.footer-brand-image {
  width: auto;
  height: auto;
  max-width: 200px;
  max-height: 100px;
  object-fit: contain;
}

.footer-company-name {
  margin: 16px 0 0;
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.5;
  color: #a0aec0; /* Slightly muted text */
  max-width: 250px;
}

.footer-office-column h4,
.footer-contact-column h4,
.footer-legal-column h4 {
  font-size: 1.15rem;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 20px;
  color: #ffffff;
  position: relative;
  padding-bottom: 10px;
}

.footer-office-column h4::after,
.footer-contact-column h4::after,
.footer-legal-column h4::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 2px;
  background-color: #007bff;
}

.footer-office-column p,
.footer-contact-column p {
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: 12px;
  color: #cbd5e0;
}

.footer-office-column p:last-child,
.footer-contact-column p:last-child {
  margin-bottom: 0;
}

.footer-contact-column a,
.footer-legal-column a,
.footer-copyright a {
  color: #cbd5e0;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-contact-column a:hover,
.footer-legal-column a:hover,
.footer-copyright a:hover {
  color: #007bff;
  text-decoration: none;
}

.footer-legal-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer-legal-list li {
  margin-bottom: 10px;
}

.footer-legal-list li:last-child {
  margin-bottom: 0;
}

.footer-legal-list a {
  font-size: 0.9rem;
  line-height: 1.6;
}

.contact-label {
  font-weight: normal;
}

.footer-bottom-bar {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2); /* Slightly darker bottom bar */
}

.footer-bottom-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 20px 24px;
}

.footer-copyright {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
}

.footer-copyright-links {
  display: inline;
  white-space: nowrap;
}

.link-separator {
  margin: 0 8px;
  color: rgba(255, 255, 255, 0.6);
}

@media (max-width: 992px) {
  .footer-container-styled {
    grid-template-columns: 1fr 1fr;
    gap: 20px 40px;
  }

  .footer-logo-social-column {
    grid-column: 1 / -1;
    align-items: center;
    margin-bottom: 10px;
  }

  .footer-company-name {
    text-align: center;
    max-width: none;
  }

  .footer-office-column,
  .footer-contact-column,
  .footer-legal-column {
    padding-top: 0;
  }
}

@media (max-width: 600px) {
  .footer-container-styled {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-logo-social-column,
  .footer-office-column,
  .footer-contact-column,
  .footer-legal-column {
    align-items: center;
    margin-bottom: 25px;
  }

  .footer-logo-social-column {
    margin-bottom: 15px;
  }

  .footer-legal-column:last-child {
    margin-bottom: 0;
  }

  .footer-office-column h4::after,
  .footer-contact-column h4::after,
  .footer-legal-column h4::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .footer-copyright-links {
    display: block;
    margin-top: 8px;
    white-space: normal;
  }

  .link-separator {
    display: none;
  }

  .footer-copyright-links a {
    display: inline-block;
    margin: 0 6px;
  }
}
</style>
